/**
 * Tento soubor slouží jako workaround pro zprovoznění importů z 'redux-saga/effects'. Při tomto importu se aplikace snaží získat
 * separátní balíček pro efekty. Ten ale neexistuje, protože redux-saga poskytuje jeden výsledný UMD balíček, který v sobě má i effects.
 * Typings pro redux-saga ale nereflektují skutečnost jednoho UMD balíčku, proto nelze v aplikaci importovat 'effects' bez použití ts-ignore.
 *
 * Tento balíček společně s nastavením aliasů v main.tsconfig.json pomocí paths umožňuje přesměrovat importy, takže v aplikaci můžeme importovat
 * efekty klasickým způsobem, který odpovídá typingům.
 */

// @ts-ignore
import {effects} from "redux-saga";

export const effectTypes = effects.effectTypes;
export const take = effects.take;
export const takeMaybe = effects.takeMaybe;
export const put = effects.put;
export const putResolve = effects.putResolve;
export const all = effects.all;
export const race = effects.race;
export const call = effects.call;
export const apply = effects.apply;
export const cps = effects.cps;
export const fork = effects.fork;
export const spawn = effects.spawn;
export const join = effects.join;
export const cancel = effects.cancel;
export const select = effects.select;
export const actionChannel = effects.actionChannel;
export const cancelled = effects.cancelled;
export const flush = effects.flush;
export const getContext = effects.getContext;
export const setContext = effects.setContext;
export const delay = effects.delay;
export const debounce = effects.debounce;
export const retry = effects.retry;
export const takeEvery = effects.takeEvery;
export const takeLatest = effects.takeLatest;
export const takeLeading = effects.takeLeading;
